var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8916 6.42987C14.0603 6.5072 14.1684 6.67573 14.1684 6.86128V14.0417C14.1684 14.3875 13.8104 14.6172 13.496 14.4731L0.276792 8.41204C0.108129 8.33471 0 8.16617 0 7.98063V0.80025C0 0.454411 0.358025 0.224702 0.672396 0.368841L13.8916 6.42987Z",
    fill: "#008440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7246 0.310144C28.039 0.165274 28.3977 0.394977 28.3977 0.741191V7.86225C28.3977 8.04689 28.2907 8.21477 28.1232 8.29261L14.8426 14.4668C14.528 14.613 14.168 14.3833 14.168 14.0364V6.85972C14.168 6.67449 14.2757 6.50618 14.444 6.42867L27.7246 0.310144Z",
    fill: "#28A864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8944 21.5068C14.062 21.5846 14.1692 21.7525 14.1692 21.9372V29.7397C14.1692 29.7674 14.1403 29.7857 14.1153 29.7738L7.50997 26.6499C7.34408 26.5714 7.23828 26.4044 7.23828 26.2209V19.1597C7.23828 18.8128 7.59818 18.5831 7.91275 18.7292L13.8944 21.5068Z",
    fill: "#008440"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4214 18.6759C20.7362 18.527 21.0989 18.7566 21.0989 19.1049V26.1603C21.0989 26.3438 20.9931 26.5109 20.8272 26.5894L14.8455 29.4184C14.5306 29.5673 14.168 29.3376 14.168 28.9893V21.9339C14.168 21.7504 14.2738 21.5833 14.4397 21.5049L20.4214 18.6759Z",
    fill: "#28A864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5847 2.81055H13.7539C13.2297 2.81055 12.8047 3.23551 12.8047 3.75973V33.0499C12.8047 33.5742 13.2297 33.9991 13.7539 33.9991H14.5847C15.1089 33.9991 15.5339 33.5742 15.5339 33.0499V3.75974C15.5339 3.23551 15.1089 2.81055 14.5847 2.81055Z",
    fill: "#008440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logo-svg.4d1cd95eb90338f0945b6add35503cce.svg";
export { ForwardRef as ReactComponent };